/* SAEGE bundle guard - keeps the zero-priced bundle pieces ("(Bundle)" twins) inside complete sets.
   Loaded on every page from snippets/head-tag.liquid.

   A valid set in the cart = lines sharing one _bundle_id property:
     exactly 1 x the "Build Your Set" price carrier (variant CARRIER)
     exactly PICK units of zero-priced twin pieces (handle ends "-bundle")
   Anything else involving the carrier or a twin (a twin with no _bundle_id, a piece quantity
   bumped up in the cart drawer, a carrier on its own, a set missing a piece) is removed as a
   group and the shopper is pointed back to the builder.

   Runs: on load, on the theme's cart-changed event, and before any checkout click.
   Server-side backstop: Shopify Flow "Bundle guard" checks every order. */
(function () {
  var CARRIER = 57267001983316;   // Build Your Set price carrier variant
  var PICK = 4;                   // pieces per set - change for a 5-piece offer
  var BUILDER = '/pages/build-your-set';
  var busy = false;

  function isTwin(l) {
    return l.variant_id !== CARRIER && /-bundle$/.test(l.handle || '') && Number(l.original_price) === 0;
  }
  function bundleId(l) {
    return (l.properties && l.properties._bundle_id) ? String(l.properties._bundle_id) : '';
  }

  function badKeys(cart) {
    var groups = {};
    (cart.items || []).forEach(function (l) {
      var c = l.variant_id === CARRIER, t = isTwin(l);
      if (!c && !t) return;
      var id = bundleId(l);
      var g = groups[id] || (groups[id] = { carrier: 0, pieces: 0, keys: [] });
      if (c) g.carrier += l.quantity; else g.pieces += l.quantity;
      g.keys.push(l.key);
    });
    var bad = [];
    Object.keys(groups).forEach(function (id) {
      var g = groups[id];
      if (!id || g.carrier !== 1 || g.pieces !== PICK) bad = bad.concat(g.keys);
    });
    return bad;
  }

  function note() {
    try {
      var el = document.getElementById('saege-bundle-guard-note');
      if (!el) {
        el = document.createElement('div');
        el.id = 'saege-bundle-guard-note';
        el.setAttribute('role', 'status');
        el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
          'background:#171717;color:#fff;font-size:13px;line-height:1.4;padding:12px 16px;max-width:calc(100% - 32px);' +
          'box-shadow:0 4px 16px rgba(0,0,0,.15);text-align:center';
        document.body.appendChild(el);
      }
      el.innerHTML = 'Bundle pieces can only be bought as a complete set. ' +
        '<a href="' + BUILDER + '" style="color:#fff;text-decoration:underline">Build your set</a>';
      clearTimeout(el._t);
      el._t = setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 8000);
    } catch (e) {}
  }

  function refresh() {
    try { document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })); } catch (e) {}
    if (/^\/cart\/?$/.test(location.pathname)) {
      try { sessionStorage.setItem('saegeGuardNote', '1'); } catch (e) {}
      location.reload();
    }
  }
  function noteAfterReload() {
    try {
      if (sessionStorage.getItem('saegeGuardNote') === '1') {
        sessionStorage.removeItem('saegeGuardNote');
        note();
      }
    } catch (e) {}
  }

  // returns a promise resolving to true if anything was removed
  function check() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = badKeys(cart);
        if (!bad.length) return false;
        var updates = {};
        bad.forEach(function (k) { updates[k] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { note(); return true; });
      })
      .catch(function () { return false; })
      .then(function (removed) {
        busy = false;
        if (removed) refresh();
        return removed;
      });
  }

  // before checkout: run the check, then continue to checkout
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"], [data-saege-checkout]'
    ) : null;
    if (!t || t.closest('[data-sbb]')) return;   // the bundle builder's own button adds a valid set
    if (t.dataset.saegeGuardOk === '1') { delete t.dataset.saegeGuardOk; return; }
    e.preventDefault();
    e.stopPropagation();
    check().then(function (removed) {
      if (removed) return;
      t.dataset.saegeGuardOk = '1';   // let the original click through this time
      t.click();
    });
  }, true);

  document.addEventListener('theme:cartchanged', function () { setTimeout(check, 150); });
  window.addEventListener('pageshow', function () { check(); });
  function start() { noteAfterReload(); check(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.SAEGE_BUNDLE_GUARD = { check: check, badKeys: badKeys };
})();
